<template>
  <div class="Listings_SortBy flex md:justify-end justify-around h-fit">
    <div class="dropdown">
      <button
        type="button"
        data-toggle="dropdown"
        class="space-x-3 text-blackest rounded-full bg-grey-lighter py-4 px-4 focus:outline-none"
      >
        <span class="font-bold">{{ finalSortOptions[sort] }}</span>
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu">
        <li
          v-for="(label, value) in finalSortOptions"
          @click="$emit('updateSort', value)"
          :key="value"
          class="px-4 py-1 cursor-pointer hover:bg-primary hover:text-white"
        >
          {{ label }}
        </li>
      </ul>
    </div>

    <div class="dropdown ml-4">
      <button
        type="button"
        data-toggle="dropdown"
        class="space-x-3 text-blackest rounded-full bg-grey-lighter py-4 px-4 focus:outline-none"
      >
        <span class="font-bold">{{ per }} per page</span>
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu">
        <li
          v-for="value in perOptions"
          @click="$emit('updatePer', value)"
          :key="value"
          class="px-4 py-1 cursor-pointer hover:bg-primary hover:text-white"
        >
          {{ value }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { computed, inject } from "vue"

const props = defineProps({
  updatePer: Function,
  updateSort: Function,
})

const sort = inject("sort")
const per = inject("per")
const activeTab = inject("activeTab")
const sortOptions = inject("sortOptions")
const perOptions = [20, 40, 60, 80, 100]

const finalSortOptions = computed(() => {
  return activeTab.value === "reprints"
    ? Object.fromEntries(Object.entries(sortOptions).filter(([key]) => key !== "originals"))
    : sortOptions
})

</script>

<script>
export default {
  name: "ArtistSort",
}
</script>
